<template>
  <!--
    	作者：qjy
    	时间：2019-10-26
    	描述：商品管理-商品编辑-规格/库存
    -->
  <div>
    <!--分销设置-->
    <div class="common-form mt50">分销设置</div>
    <el-form-item label="是否开启单独分销：">
      <el-radio-group v-model="form.model.is_ind_agent">
        <el-radio :label="0">关闭</el-radio>
        <el-radio :label="1">开启</el-radio>
      </el-radio-group>
      <div class="gray9">开启后，下面的收益才会产生</div>
    </el-form-item>
    <template v-if="form.model.is_ind_agent === 1">
      <el-form-item label="分销佣金类型：">
        <el-radio-group v-model="form.model.agent_money_type">
          <el-radio :label="10">百分比</el-radio>
          <el-radio :label="20">固定金额</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分销佣金类型：">
        <el-radio-group v-model="form.model.agent_type">
          <el-radio :label="10">普通设置</el-radio>
          <el-radio :label="20">详细设置</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="Number(form.model.agent_type) === 10">
        <el-form-item label="单独分销设置：" >
          <el-input type="number" min="0" v-model="form.model.first_money" class="max-w460">
            <template slot="prepend">
              一级佣金：
            </template>
            <template slot="append">
              {{ unit }}
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="number" min="0" v-model="form.model.second_money" class="max-w460">
            <template slot="prepend">
              二级佣金：
            </template>
            <template slot="append">
              {{ unit }}
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="number" min="0" v-model="form.model.third_money" class="max-w460">
            <template slot="prepend">
              三级佣金：
            </template>
            <template slot="append">
              {{ unit }}
            </template>
          </el-input>
        </el-form-item>
      </div>
      <div v-if="Number(form.model.agent_type) === 20"  class="max-w960">
        <el-form-item>
          <el-table :data="form.gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="会员等级"></el-table-column>
            <el-table-column prop="name" label="金额">
              <template v-slot="scope">
                <!-- {{scope.row}} -->
                <div class="d-s-c">
                  <el-input v-model="scope.row.independent_commission.first_money" type="number" placeholder="请输入金额">
                    <template slot="prepend">
                      一级佣金：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                </div>
                <div class="d-s-c">
                  <el-input v-model="scope.row.independent_commission.second_money" type="number" placeholder="请输入金额">
                    <template slot="prepend">
                      二级佣金：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                </div>
                <div class="d-s-c">
                  <el-input v-model="scope.row.independent_commission.third_money" type="number" placeholder="请输入金额">
                    <template slot="prepend">
                      三级佣金：
                    </template>
                    <template slot="append">
                      {{ unit }}
                    </template>
                  </el-input>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </div>
    </template>
    <el-form-item label="直推佣金">
      <el-input type="number" min="0" v-model="form.model.direct_commission" class="max-w460">
      </el-input>
      <div class="gray9">仅做显示例,不参与实际返利 </div>
    </el-form-item>

    <el-form-item label="返佣模式">
      <el-checkbox-group v-model="form.model.commission_type">
        <el-checkbox v-for="(item,index) in form.commission_list" :label="item.id" :key="index">{{ item.name }}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>

    <el-form-item label="代理收益">
      <el-input type="number" min="0" v-model="form.model.agent_level" class="max-w460"><template slot="append">%</template></el-input>
      <el-input type="number" min="0" v-model="form.model.agent_level_fixed_amount" class="max-w460"><template slot="append">元</template></el-input>
      <div class="gray9">购买者的最近代理收益，两个都填写的情况，优先选择百分比</div>
    </el-form-item>
    <el-form-item label="平级收益">
      <el-input type="number" min="0" v-model="form.model.equal_level" class="max-w460"><template slot="append">%</template></el-input>
      <el-input type="number" min="0" v-model="form.model.equal_level_fixed_amount" class="max-w460"><template slot="append">元</template></el-input>
      <div class="gray9">平级收益，两个都填写的情况，优先选择百分比</div>
    </el-form-item>
    <el-form-item label="达人购买分销自购">
      <el-radio-group v-model="form.model.self_buy">
        <el-radio :label="-1">跟随全局</el-radio>
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
      <div class="tips">前提是达人购物的情况下才生效，如开启，达人等级购买商品，购买者获得一级佣金</div>
    </el-form-item>
    <el-form-item label="是否计算业绩参与年终奖">
      <el-radio-group v-model="form.model.no_performance">
        <el-radio :label="0">计算</el-radio>
        <el-radio :label="1">不计算</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- <el-form-item label="推三全返">
      <el-radio-group v-model="form.model.three_full_back">
        <el-radio :label="0">关闭</el-radio>
        <el-radio :label="1">开启</el-radio>
      </el-radio-group>
      <div class="tips">如果选择开启，用户购买后可享受 推荐三单购买，当前订单全返。开启后产品不算业绩</div>
    </el-form-item> -->

  </div>
</template>

<script>
export default {
  components: {},
  inject: ['form'],
  data() {
    return {

    }
  },
  computed: {
    unit() {
      return Number(this.form.model.agent_money_type) === 10 ? '%' : '元'
    }
  },
  methods: {

  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Commission.vue